import { createRouter, type RouterHistory } from '@tanstack/react-router'

import { routeTree } from '~/routeTree.gen'

export interface CreateAppRouterOptions {
  /** Overridden in tests to drive the router without a real browser history. */
  history?: RouterHistory
}

export function createAppRouter(options: CreateAppRouterOptions = {}) {
  return createRouter({
    routeTree,
    defaultPreload: 'intent',
    // History traversal uses the same transition as links, so a page face can fly back into
    // the timeline thumbnail it came from instead of only making the outward trip.
    defaultViewTransition: true,
    scrollRestoration: true,
    /*
     * The timeline is one place however it is come back to — `/specs/app.spec.md`, The day
     * pill: left and come back to, it stands exactly where it was left, which a scroll kept per
     * visit could never say of a visit made by pressing Training. Every other page keeps its
     * scroll per visit, the router's own way.
     */
    getScrollRestorationKey: (location) =>
      location.pathname === '/' ? '/' : (location.state.__TSR_key ?? location.href),
    ...options,
  })
}

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof createAppRouter>
  }
}
